import { createToastInterface } from "vue-toastification";

export default function (ctx, inject) {
  const toast = createToastInterface({"cssFile":"\u002Fvar\u002Fwww\u002Fqanoniah.com\u002Fnode_modules\u002Fvue-toastification\u002Fdist\u002Findex.css","transition":"Vue-Toastification__fade","position":"bottom-left"});
  inject('toast', toast);
}
